import { useQuery } from '@tanstack/react-query';
import { terraProxyApiClient } from '../../clients/testerClient';

export const AI_APPLICATION_KEY = 'ai-application';

const STALE_TIME_MS = 30_000;

export function useAiApplication({
  aiApplicationId,
  enabled = true,
}: {
  aiApplicationId: string | null;
  enabled?: boolean;
}) {
  const query = useQuery({
    queryKey: [AI_APPLICATION_KEY, aiApplicationId],
    queryFn: () => terraProxyApiClient.getAiApplication(aiApplicationId ?? ''),
    enabled: Boolean(aiApplicationId) && enabled,
    staleTime: STALE_TIME_MS,
  });

  return {
    aiApplication: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}
